module.exports = __webpack_public_path__ + "img/fig03.2538f620.jpg";